import { render, staticRenderFns } from "./DialogArticles.vue?vue&type=template&id=790c23fa&scoped=true"
import script from "./DialogArticles.vue?vue&type=script&lang=js"
export * from "./DialogArticles.vue?vue&type=script&lang=js"
import style0 from "./DialogArticles.vue?vue&type=style&index=0&id=790c23fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790c23fa",
  null
  
)

export default component.exports